var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "ul",
    {
      staticClass: "widget-list widget-links sidebar-views cw-view-widget",
    },
    [
      _c(
        "li",
        {
          class: {
            active: _vm.templatesView,
          },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "#",
              },
              on: {
                click: function click($event) {
                  $event.preventDefault()
                  return _vm.setTemplatesView.apply(null, arguments)
                },
              },
            },
            [_c("translate", [_vm._v("Vorlagen")])],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }